import axios from 'axios';
import { baseURL, base_star_url, base_star_plan_url } from './baseURL';
import {
  requestBefore,
  requestFail,
  responseBefore,
  responseFail,
  requestJavaBefore
} from './interceptors';

const instance = axios.create({
  baseURL,
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded',
  },
});
//创建激励数据请求实例
const mstance = axios.create({
  baseURL: baseURL,
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded',
  },
});
//获取星启计划内容
const starInstance = axios.create({
  baseURL: base_star_url,
  headers: {
    'Content-Type': 'application/json',
  },
});
//星启计划时长激励参与
const starPlanInstance = axios.create({
  baseURL: base_star_plan_url,
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded',
  },
});
//添加请求拦截器
starPlanInstance.interceptors.request.use(requestJavaBefore, requestFail);
// 设置默认超时时间 - 60s。
instance.defaults.timeout = 60000;

// 添加请求拦截器
instance.interceptors.request.use(requestBefore, requestFail);
mstance.interceptors.request.use(requestBefore, requestFail);
// 添加响应拦截器
instance.interceptors.response.use(responseBefore, responseFail);

export { instance, mstance, starInstance, starPlanInstance };
